import {Link} from "react-router-dom";
import {Helmet} from "react-helmet";

export default function NotFoundPage()
{
    return (<section className="page-404 pt" style={{padding: "300px 0"}}>
        <Helmet>
            <meta name="prerender-status-code" content="404"/>
        </Helmet>
        <div className="page-404__wrap">
            <h4 className="f-exp">
                404 Error
                <br/> К сожалению, запрашиваемой Вами страницы не существует
            </h4>
            <p>
                Возможно Вы перешли по устаревшей ссылке или
                <br className="mob"/> набрали адрес несуществующей страницы.
            </p>
        </div>
    </section>)
}